import React from 'react';
import { observer } from 'mobx-react';
import { CardInfoToolBar, CardMainLayout, Catcher, FieldInfo, LinkComponent, cardLayoutOptions } from '../../';
import { IShowForm } from '../../../interfaces';
import { useRateInfo } from '../../../hooks';
import { showPrice } from '../../../instruments';

type IShowRateInfo = IShowForm & {
    isV2?: boolean;
};

export const ShowRateInfo: React.FC<IShowRateInfo> = observer(({ setEditMode }: IShowRateInfo) => {
    const rateInfo = useRateInfo();
    const editMode = !rateInfo.outerAssignment ? setEditMode : undefined;
    return (
        <Catcher>
            <CardMainLayout
                idSpinners={['GET_RATE_UNIT_TYPE_SELECT']}
                name={rateInfo.name}
                columnOption={cardLayoutOptions.salesRateInfo}
            >
                <FieldInfo title={'Name'}>{rateInfo.name}</FieldInfo>
                <FieldInfo title={'Company'}>
                    <LinkComponent
                        currentListComponent={'CompaniesList'}
                        id={rateInfo.companyId}
                        name={rateInfo.company}
                    />
                </FieldInfo>
                <FieldInfo title={'Currency'}>{rateInfo.currency}</FieldInfo>
                <FieldInfo title={'Notes'}>{rateInfo.notes}</FieldInfo>
                <FieldInfo title={'Default data rate'} titleSuffix={'p/GB'}>
                    {showPrice(rateInfo.calculatedRateData, rateInfo.currency)}
                </FieldInfo>
                <FieldInfo title={'Default sms rate'} titleSuffix={'p/GB'}>
                    {showPrice(rateInfo.calculatedRateSms, rateInfo.currency)}
                </FieldInfo>
                <FieldInfo title={'Default voice mobile rate'} titleSuffix={'p/GB'}>
                    {showPrice(rateInfo.calculatedRateVoiceMobile, rateInfo.currency)}
                </FieldInfo>
                <FieldInfo title={'Default voice fix net rate'} titleSuffix={'p/GB'}>
                    {showPrice(rateInfo.calculatedRateVoiceNet, rateInfo.currency)}
                </FieldInfo>
                <CardInfoToolBar setEditMode={editMode} />
            </CardMainLayout>
        </Catcher>
    );
});
